$(document).ready(function() { 
  
  $('<div id="bottom-section-wrapper"></div>').appendTo('#MainContent');
  $('#bottom-section').appendTo('#bottom-section-wrapper').show();
  $('#collectionfaq').appendTo('#bottom-section-wrapper').show();
  $('.collection-list').on('init', function(event, slick){
    $('.collection-list .collection-list__item').removeClass('colitemloading');
  });
  $(".quickview").colorbox();
  $(".colorboxinline").colorbox({inline:true});
  $(".collection-list").slick({
    infinite: false,
    mobileFirst:true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          infinite: true
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      },	
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      }]
  });


  var starsectioninit = {
    autoplay: true,
    infinite: true,
    mobileFirst:true,
    arrows: true,		
    dots: false,
    speed: 1500,    	
    touchMove: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 2,
          arrows: true          
        }
      }
    ]
  };

  var windowWidth = $(window).width();
  $(function () {
    var starsectionwin = $(window);
    var slider = $(".starsection");
  
    starsectionwin.on("load resize", function () {
      if (starsectionwin.width() < 768) {
        slider.not(".slick-initialized").slick(starsectioninit);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    });
  });

  var announcementBREAKPOINT = 768;
  var announcementSlideIndex = 0;
  var announcementSlider = ".top-announcement";

  var announcementSliderConfig = {
      arrows: true,
      mobileFirst:true,
      infinite: true,
      dots: false,
      //autoplay: true,
      speed: 1500,
      //vertical: true,
      slidesToShow: 3,
      touchMove: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fas fa-chevron-right"></i></button>',
      responsive: [          
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            slidesToShow: 3,
            arrows: true
          }
        }
      ]
  };
  
  if (windowWidth >= announcementBREAKPOINT) {
  
  } else {
    var resizeTimeout;
    $(window).resize(function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            var windowWidth = $(window).width();
            if (windowWidth >= announcementBREAKPOINT) {
                //desktop
                if ($('.top-announcement.slick-initialized').size() > 0) {
                    $(announcementSlider).slick("unslick");
                }	
            } else {
                // mobile
                if ($('.top-announcement.slick-initialized').size() == 0) {
                    //console.log('slick first time');
                    $(announcementSlider).slick(announcementSliderConfig);
                } else {
                    $(announcementSlider).slick("unslick").slick(announcementSliderConfig);
                    $(announcementSlider).slick('slickGoTo', announcementSlideIndex, true);
                }				
            }
        }, 300);
    });
  }
  jQuery('.jdgm-prev-badge').click(function(event){
    jQuery('.tablinks, .tabcontent').removeClass('active');
    jQuery('.tablinks.productreviews').addClass('active');
    jQuery('#productreviews').show();
  });
      
});

$(document).ready(function () {
  updateHeaderWishlistCount();
});

function updateHeaderWishlistCount(){
  function getwishlistCookie(cname) {
    var name = decodeURIComponent( unescape( unescape(cname + "=")));
    
    var decodedCookie = decodeURIComponent( unescape( unescape(document.cookie)) );
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var bvwishlist = getwishlistCookie('bvwishlist');

  var bvwishlist = getwishlistCookie('bvwishlist');
  var bvwishlist_json = JSON.parse(bvwishlist);
  if (bvwishlist_json.items.length > 0) {
    jQuery('.bvwishcountheader').html('<span>'+bvwishlist_json.items.length+'</span');
  } else {
    jQuery('.bvwishcountheader').html('');
  }
}

jQuery(document).ready(function(){

    jQuery('.boost-pfs-filter-close').click(function(){
      jQuery('body').removeClass('boost-pfs-filter-tree-open-body');
      jQuery('body .boost-pfs-filter-tree').removeClass('boost-pfs-filter-tree-mobile-open');
    });
	var limespotmin = setInterval(checklimespot, 3000);
	function checklimespot(){
		if(jQuery('.limespot-recommendation-box-carousel-shelf').length > 0){
			clearInterval(limespotmin);
			limespotomeadd("ul.limespot-recommendation-box-carousel-shelf .limespot-recommendation-box-item");
		}
	}
  
	function limespotomeadd(lsClassName){      
      $(lsClassName).each(function() {
		
        var $this = jQuery(this);
        var installementText = '';
        var wishlisticon = '';
        var productId = $this.find('.ls-link').attr('data-product-identifier'); 
        var productLink = $this.find('.ls-link').attr('href'); 
        
        var productHandle = productLink.split("?");
        productHandle = productHandle[0].split("products/")[1];
    
        wishlisticon = '<span class="wishlistitem ftc"><a class="wishlistatag" data-product='+productId+' data-producthandle='+productHandle+' href="javascript:void(0)"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.83 21.32"><defs><style>.heart-icon{fill:#d7b258;stroke:#fff;stroke-miterlimit:10;stroke-width:0.83px;}</style></defs><path class="heart-icon" d="M297.49,414.47c.58-.69,1.12-1.35,1.69-2a5.83,5.83,0,0,1,4.72-2.13,5.58,5.58,0,0,1,5.09,6,9.64,9.64,0,0,1-2.49,5.82,59.58,59.58,0,0,1-6.52,6.39c-.81.72-1.63,1.42-2.47,2.15l-1.6-1.37a78.25,78.25,0,0,1-6.68-6.33,12.77,12.77,0,0,1-2.6-3.84,6.77,6.77,0,0,1,.23-6.18,5.29,5.29,0,0,1,6.53-2.25,8.07,8.07,0,0,1,2.94,2.32C296.72,413.5,297.09,414,297.49,414.47Z" transform="translate(-285.59 -409.93)"></path></svg></a></span>';
        $this.find('.ls-image-wrap').append(wishlisticon);	
      });
	}
  
  	/*$('.banner-text-desc .readmore').click(function(){
  		$('.banner-text-desc .banner-text-desc-short').hide();
      	$('.banner-text-desc .banner-text-desc-full').slideDown();
  	});
  
  	$('.banner-text-desc .readless').click(function(){
  		$('.banner-text-desc .banner-text-desc-short').show();
      	$('.banner-text-desc .banner-text-desc-full').slideUp();
  	});*/
  
  	function AddReadMore() {
    	var carLmt = 200;
    	var readMoreTxt = " Read More >";
    	var readLessTxt = " < Read Less";

    	$(".addReadMore").each(function() {
        	if ($(this).find(".firstSec").length)
            	return;

        	var allstr = $(this).text();
          
        	if (allstr.length > carLmt) {
            	var firstSet = allstr.substring(0, carLmt);
            	var secdHalf = allstr.substring(carLmt, allstr.length);
            	var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
            	$(this).html(strtoadd);
        	}
    	});

        $(document).on("click", ".readMore,.readLess", function() {
            $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
        });
	}
    $(function() {
        //Calling function after Page Load
        AddReadMore();
    });
  
  	//equalheight('.grid__item .card-information .price_sale_wrapper');
    $(".accordion-title").click(function () {
      $(".open").not(this).removeClass("open").next().slideUp(300);
      $(this).toggleClass("open").next().slideToggle(300);
    });
});

/*$( window ).load(function() {
  equalheight('.grid__item .card-information .price_sale_wrapper');
});*/

// equal height testimonials block
equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}